module.exports = __webpack_public_path__ + "static/media/airblitz-3.2b082369.jpg";